<template>
  <v-sheet
    class="px-6 npo-card mb-4"
    color="white"
    tile
    :height="'auto'"
    @click="$emit('option-selected', option.id)"
    :class="{ 'npo-selected': selected }"
    :style="styleObject"
  >
    <div class="pa-4 text-center primary dark" style="color: white; font-size: 1.1rem">
      {{ option.answer }}
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    option: {
      type: Object
    }
  },
  data () {
    return {
      styleObject: {
        transform: 'translate(0px, 0px)'
      },
      selected: false,
      leadId: null,
      campaignId: null,
      campaign: null
    }
  },

  created () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaignId = campaign.campaign_id
      this.campaign = campaign
    } else {
      this.campaignId = sessionStorage.getItem('campaign_id')
      this.leadId = sessionStorage.getItem('lead_id')
    }
  }
}
</script>
<style scoped>
.v-navigation-drawer {
  transition: none !important;
}

.v-content {
  background-color: #fff;
}

.npo-card {
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.56, 0, 0.56, 1.29);
}
.npo-selected {
  z-index: 100;
  border-radius: 0;
  border: 0;
  width: 100vw;
  height: 100vh !important;
}
.npo-name {
  font-size: 2rem;
}
</style>
